import RecepcionListStore from './recepcion/state/RecepcionListStore';
import RecepcionInfoStore from './recepcion/state/RecepcionInfoStore';
import SociosDeNegocioStore from './socios/state/SociosDeNegocioStore';
import TimbradoSftpStore from './timbrado-sftp/state/TimbradoSftpStore';
import CancelacionesStore from './cancelaciones/state/CancelacionesStore';
import RecepcionUploadStore from './recepcion/state/RecepcionUploadStore';
import TimbradoMasivoStore from './timbrado-masivo/state/TimbradoMasivoStore';
import AutofacturacionStore from './autofacturacion/state/AutofacturacionStore';
import CatalogoClienteStore from './catalogo-cliente/state/CatalogoClienteStore';
import FacturasGlobalesStore from './facturas-globales/state/FacturasGlobalesStore';
import RetencionesMasivasStore from './retenciones-masivas/state/RetencionesMasivasStore';

const ModuloStore = {
  fpg: FacturasGlobalesStore,
  autofacturacion: AutofacturacionStore,
  catalogo: {
    cliente: CatalogoClienteStore,
  },
  cancelaciones: CancelacionesStore,
  socios: SociosDeNegocioStore,
  timbrado_sftp: TimbradoSftpStore,
  timbrado_masivo: TimbradoMasivoStore,
  retenciones_masivas: RetencionesMasivasStore,
  recepcion: {
    list: RecepcionListStore,
    info: RecepcionInfoStore,
    upload: RecepcionUploadStore,
  },
};

export default ModuloStore;
